import { useState, useEffect } from 'react';
import { api } from '../api';

const TECNICO_REQ = 'Alfonso'; // Técnico fijo de requerimientos
const URGENCIAS = [
  { key: 'normal',  label: '⚪ Normal',  color: '#555'    },
  { key: 'urgente', label: '🟡 Urgente', color: '#ffc107' },
  { key: 'critico', label: '🔴 Crítico', color: '#e63946' },
];

// ══════════════════════════════════════════════════════════════
// Requerimientos — Vista Técnico
// ══════════════════════════════════════════════════════════════
export default function Requerimientos() {
  const [vista,    setVista]    = useState('marca');   // marca | nuevo | historial
  const tecnico = TECNICO_REQ;
  // ── Estado tab Por Marca ──
  const [marcas,         setMarcas]         = useState([]);
  const [busqMarca,      setBusqMarca]      = useState('');
  const [marcaActiva,    setMarcaActiva]    = useState('');
  const [productosMarca, setProductosMarca] = useState([]);
  const [cargandoMarca,  setCargandoMarca]  = useState(false);
  const [busqProd,       setBusqProd]       = useState('');
  const [busq,     setBusq]     = useState('');
  const [items,    setItems]    = useState([]);
  const [nota,     setNota]     = useState('');
  const [buscando, setBuscando] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [cargandoHist, setCargandoHist] = useState(false);
  const [exito, setExito]       = useState(null);
  // ── Modal detalle/edición historial ──
  const [modalReq,     setModalReq]     = useState(null);  // {id, estado, items}
  const [cargandoMod,  setCargandoMod]  = useState(false);
  const [eliminando,   setEliminando]   = useState(null);  // id item eliminando

  useEffect(() => {
    if (vista === 'historial') cargarHistorial();
    if (vista === 'marca' && marcas.length === 0) cargarMarcas();
  }, [vista]);

  useEffect(() => {
    if (marcaActiva) cargarProductosMarca(marcaActiva);
  }, [marcaActiva]);

  const cargarMarcas = async () => {
    try {
      const data = await api.get('/inventario/marcas');
      setMarcas(data.marcas || []);
    } catch(e) { console.error(e); }
  };

  const cargarProductosMarca = async (marca) => {
    setCargandoMarca(true);
    setProductosMarca([]);
    setBusqProd('');
    try {
      const data = await api.get(`/reposicion/manual?marca=${encodeURIComponent(marca)}`);
      setProductosMarca(data.productos || []);
    } catch(e) { console.error(e); }
    finally { setCargandoMarca(false); }
  };

  // ── Búsqueda de items ───────────────────────────────────────
  const buscarItems = async () => {
    if (!busq.trim()) return;
    setBuscando(true);
    setResultados([]);
    try {
      const data = await api.get(`/requerimientos/buscar-items?q=${encodeURIComponent(busq)}`);
      setResultados(data.items || []);
    } catch(e) { console.error(e); }
    finally { setBuscando(false); }
  };

  const agregarItem = (item) => {
    if (items.find(i => i.codigo_bar === item.codigo_bar)) return;
    setItems([...items, {
      ...item,
      cantidad_sugerida: 1,
      urgencia: 'normal',
      nota_item: '',
    }]);
    setResultados([]);
    setBusq('');
  };

  const actualizarItem = (idx, campo, valor) => {
    setItems(items.map((it, i) => i === idx ? { ...it, [campo]: valor } : it));
  };

  const eliminarItem = (idx) => {
    setItems(items.filter((_, i) => i !== idx));
  };

  // ── Enviar requerimiento ────────────────────────────────────
  const enviar = async () => {
    if (!tecnico)       return alert('Selecciona tu nombre');
    if (!items.length)  return alert('Agrega al menos un ítem');
    setEnviando(true);
    try {
      const res = await api.post('/requerimientos', {
        tecnico,
        nota_general: nota,
        items: items.map(i => ({
          codigo_bar:        i.codigo_bar,
          descripcion:       i.descripcion,
          marca_item:        i.marca,
          cantidad_sugerida: parseFloat(i.cantidad_sugerida) || 1,
          urgencia:          i.urgencia,
          nota_item:         i.nota_item,
        })),
      });
      if (res.ok) {
        setExito(res.req_id);
        setItems([]);
        setNota('');
      }
    } catch(e) { alert('Error al enviar'); }
    finally { setEnviando(false); }
  };

  // ── Historial ───────────────────────────────────────────────
  const cargarHistorial = async () => {
    setCargandoHist(true);
    try {
      const data = await api.get(`/requerimientos?tecnico=${encodeURIComponent(tecnico)}`);
      setHistorial(data.requerimientos || []);
    } catch(e) { console.error(e); }
    finally { setCargandoHist(false); }
  };

  const abrirModal = async (r) => {
    setCargandoMod(true);
    setModalReq({ id: r.id, estado: r.estado, items: [] });
    try {
      const data = await api.get(`/requerimientos/${r.id}`);
      setModalReq({ id: r.id, estado: r.estado, items: data.items || [] });
    } catch(e) { console.error(e); }
    finally { setCargandoMod(false); }
  };

  const eliminarItemReq = async (req_id, item_id) => {
    setEliminando(item_id);
    try {
      await api.delete(`/requerimientos/${req_id}/item/${item_id}`);
      setModalReq(prev => ({
        ...prev,
        items: prev.items.filter(i => i.id !== item_id),
      }));
      // Refrescar historial para actualizar conteo
      cargarHistorial();
    } catch(e) { alert('Error al eliminar item'); }
    finally { setEliminando(null); }
  };

  const ESTADO_STYLE = {
    pendiente:  { bg: '#2a2a1a', color: '#ffc107', label: '⏳ Pendiente'  },
    revisado:   { bg: '#1a2a3a', color: '#4cc9f0', label: '👁️ Revisado'  },
    importado:  { bg: '#1a3a2a', color: '#4caf50', label: '✅ Importado'  },
    descartado: { bg: '#2a1a1a', color: '#555',    label: '🚫 Descartado' },
  };

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ color: '#fff', margin: 0 }}>📋 Requerimientos</h2>
          <p style={{ color: '#555', fontSize: 12, marginTop: 4 }}>
            Solicita productos al gerente para generar pedidos
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {[
            { key: 'marca',     label: '🏷️ Por Marca'  },
            { key: 'nuevo',     label: '🔍 Búsqueda'   },
            { key: 'historial', label: '📂 Historial'  },
          ].map(v => (
            <button key={v.key}
              style={{
                background: vista === v.key ? '#1a2a3e' : 'none',
                border: vista === v.key ? '1px solid #4cc9f0' : '1px solid #2d2d44',
                borderRadius: 8, color: vista === v.key ? '#4cc9f0' : '#888',
                padding: '8px 18px', cursor: 'pointer', fontSize: 13, fontWeight: 'bold',
              }}
              onClick={() => { setVista(v.key); setExito(null); }}>
              {v.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Vista: Por Marca ── */}
      {vista === 'marca' && (
        <div style={{ display: 'flex', gap: 0, height: 'calc(100vh - 200px)', minHeight: 500 }}>

          {/* Panel izquierdo — lista de marcas */}
          <div style={{ width: 200, background: '#1a1a2e', borderRadius: '12px 0 0 12px',
            display: 'flex', flexDirection: 'column', overflow: 'hidden', flexShrink: 0 }}>
            <div style={{ padding: '12px 12px 8px', borderBottom: '1px solid #2d2d44' }}>
              <input
                style={{ width: '100%', background: '#0f0f1a', border: '1px solid #2d2d44',
                  borderRadius: 6, color: '#fff', padding: '7px 10px', fontSize: 12, boxSizing: 'border-box' }}
                placeholder="Buscar marca..."
                value={busqMarca}
                onChange={e => setBusqMarca(e.target.value)}
              />
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {marcas
                .filter(m => !busqMarca || m.toLowerCase().includes(busqMarca.toLowerCase()))
                .map((m, i) => (
                  <div key={i}
                    style={{
                      padding: '10px 14px', cursor: 'pointer', fontSize: 13,
                      background: marcaActiva === m ? '#1a2a3e' : 'transparent',
                      color: marcaActiva === m ? '#4cc9f0' : '#aaa',
                      borderLeft: marcaActiva === m ? '3px solid #4cc9f0' : '3px solid transparent',
                    }}
                    onClick={() => setMarcaActiva(m)}>
                    {m}
                  </div>
                ))}
            </div>
          </div>

          {/* Panel derecho — productos */}
          <div style={{ flex: 1, background: '#1e1e2e', borderRadius: '0 12px 12px 0',
            display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

            {!marcaActiva ? (
              <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#555', flexDirection: 'column', gap: 12 }}>
                <span style={{ fontSize: 36 }}>🏷️</span>
                <span>Selecciona una marca para ver sus productos</span>
              </div>
            ) : (
              <>
                {/* Header marca */}
                <div style={{ padding: '14px 20px', borderBottom: '1px solid #2d2d44',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <span style={{ color: '#fff', fontWeight: 'bold', fontSize: 15 }}>🏷️ {marcaActiva}</span>
                    {!cargandoMarca && (
                      <span style={{ color: '#555', fontSize: 12, marginLeft: 10 }}>
                        {productosMarca.filter(p =>
                          !busqProd || p.item.toLowerCase().includes(busqProd.toLowerCase()) ||
                          p.codigo_bar.toLowerCase().includes(busqProd.toLowerCase())
                        ).length} productos
                      </span>
                    )}
                  </div>
                  <input
                    style={{ background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 6,
                      color: '#fff', padding: '7px 12px', fontSize: 12, width: 240 }}
                    placeholder="Buscar por código o descripción..."
                    value={busqProd}
                    onChange={e => setBusqProd(e.target.value)}
                  />
                </div>

                {/* Tabla productos */}
                {cargandoMarca ? (
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>
                    Cargando productos...
                  </div>
                ) : (
                  <>
                    <div style={{ display: 'flex', padding: '8px 20px', color: '#555',
                      fontSize: 11, fontWeight: 'bold', borderBottom: '1px solid #2d2d44' }}>
                      <span style={{ width: 130 }}>CÓDIGO</span>
                      <span style={{ flex: 1 }}>DESCRIPCIÓN</span>
                      <span style={{ width: 80, textAlign: 'center' }}>STOCK</span>
                      <span style={{ width: 100, textAlign: 'center' }}>AGREGAR</span>
                    </div>
                    <div style={{ flex: 1, overflowY: 'auto' }}>
                      {productosMarca
                        .filter(p => !busqProd ||
                          p.item.toLowerCase().includes(busqProd.toLowerCase()) ||
                          p.codigo_bar.toLowerCase().includes(busqProd.toLowerCase()))
                        .map((p, i) => {
                          const yaAgregado = items.find(it => it.codigo_bar === p.codigo_bar);
                          return (
                            <div key={i} style={{
                              display: 'flex', alignItems: 'center', padding: '9px 20px',
                              background: yaAgregado ? '#1a3a2a' : i%2===0 ? '#1e1e2e' : '#1a1a2e',
                              borderBottom: '1px solid #151525',
                            }}>
                              <span style={{ width: 130, color: '#4cc9f0', fontSize: 12,
                                fontFamily: 'monospace', flexShrink: 0 }}>
                                {p.codigo_bar}
                              </span>
                              <span style={{ flex: 1, color: yaAgregado ? '#4caf50' : '#fff', fontSize: 13 }}>
                                {p.item}
                              </span>
                              <span style={{ width: 80, textAlign: 'center',
                                color: p.stock > 0 ? '#4caf50' : '#e63946',
                                fontWeight: 'bold', fontSize: 14 }}>
                                {p.stock}
                              </span>
                              <div style={{ width: 100, textAlign: 'center' }}>
                                {yaAgregado ? (
                                  <span style={{ color: '#4caf50', fontSize: 20 }}>✓</span>
                                ) : (
                                  <button
                                    style={{
                                      background: '#4cc9f0', border: 'none',
                                      borderRadius: 6, color: '#0f0f1a',
                                      padding: '6px 14px', cursor: 'pointer',
                                      fontSize: 12, fontWeight: 'bold',
                                    }}
                                    onClick={() => agregarItem({
                                      codigo_bar:  p.codigo_bar,
                                      descripcion: p.item,
                                      marca:       p.marca,
                                    })}>
                                    + Agregar
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* ── Vista: Nuevo Requerimiento (búsqueda libre) ── */}
      {vista === 'nuevo' && (
        <div>
          {/* Éxito */}
          {exito && (
            <div style={{ background: '#1a3a2a', border: '1px solid #4caf50', borderRadius: 12,
              padding: 20, marginBottom: 20, textAlign: 'center' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
              <div style={{ color: '#4caf50', fontSize: 16, fontWeight: 'bold' }}>
                Requerimiento #{exito} enviado al gerente
              </div>
              <div style={{ color: '#aaa', fontSize: 12, marginTop: 4 }}>
                El gerente lo revisará y generará el pedido
              </div>
              <button
                style={{ marginTop: 16, background: '#4caf50', border: 'none', borderRadius: 8,
                  color: '#fff', padding: '10px 24px', cursor: 'pointer', fontWeight: 'bold' }}
                onClick={() => setExito(null)}>
                Crear otro requerimiento
              </button>
            </div>
          )}

          {!exito && (
            <>
              {/* Técnico fijo */}
              <div style={{ ...s.card, display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 24 }}>👨‍🔧</span>
                <div>
                  <div style={{ color: '#fff', fontWeight: 'bold' }}>{tecnico}</div>
                  <div style={{ color: '#555', fontSize: 11 }}>Técnico de requerimientos</div>
                </div>
              </div>

              {/* Buscador de items */}
              <div style={s.card}>
                <div style={s.cardTitulo}>Buscar productos</div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  <input
                    style={s.input}
                    placeholder="Código de barra o nombre del producto..."
                    value={busq}
                    onChange={e => setBusq(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && buscarItems()}
                  />
                  <button style={s.btnBuscar} onClick={buscarItems} disabled={buscando}>
                    {buscando ? '...' : '🔍 Buscar'}
                  </button>
                </div>

                {/* Resultados búsqueda */}
                {resultados.length > 0 && (
                  <div style={{ border: '1px solid #2d2d44', borderRadius: 8, overflow: 'hidden' }}>
                    {resultados.map((r, i) => (
                      <div key={i}
                        style={{ display: 'flex', alignItems: 'center', gap: 12,
                          padding: '10px 14px', background: i%2===0?'#1a1a2e':'#1e1e2e',
                          cursor: 'pointer', borderBottom: '1px solid #2d2d44' }}
                        onClick={() => agregarItem(r)}>
                        <div style={{ flex: 1 }}>
                          <div style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>{r.descripcion}</div>
                          <div style={{ color: '#555', fontSize: 11 }}>{r.codigo_bar} · {r.marca}</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ color: r.stock > 0 ? '#4caf50' : '#e63946', fontSize: 12 }}>
                            Stock: {r.stock}
                          </div>
                        </div>
                        <span style={{ color: '#4cc9f0', fontSize: 18 }}>+</span>
                      </div>
                    ))}
                  </div>
                )}
                {resultados.length === 0 && busq && !buscando && (
                  <p style={{ color: '#555', fontSize: 12 }}>Sin resultados para "{busq}"</p>
                )}
              </div>

              {/* Items agregados */}
              {items.length > 0 && (
                <div style={s.card}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <div style={s.cardTitulo}>Productos solicitados ({items.length})</div>
                  </div>

                  {items.map((item, idx) => {
                    const urg = URGENCIAS.find(u => u.key === item.urgencia) || URGENCIAS[0];
                    return (
                      <div key={idx} style={{
                        background: '#0f0f1a', borderRadius: 10, padding: 14,
                        marginBottom: 10, borderLeft: `3px solid ${urg.color}`,
                      }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                          <div>
                            <div style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>{item.descripcion}</div>
                            <div style={{ color: '#555', fontSize: 11 }}>{item.codigo_bar} · {item.marca}</div>
                          </div>
                          <button
                            style={{ background: 'none', border: 'none', color: '#e63946', cursor: 'pointer', fontSize: 18 }}
                            onClick={() => eliminarItem(idx)}>✕</button>
                        </div>

                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                          {/* Cantidad */}
                          <div>
                            <div style={s.fieldLabel}>Cantidad sugerida</div>
                            <input
                              type="number" min="1" style={{ ...s.inputSmall, width: 80 }}
                              value={item.cantidad_sugerida}
                              onChange={e => actualizarItem(idx, 'cantidad_sugerida', e.target.value)}
                            />
                          </div>

                          {/* Urgencia */}
                          <div>
                            <div style={s.fieldLabel}>Urgencia</div>
                            <div style={{ display: 'flex', gap: 6 }}>
                              {URGENCIAS.map(u => (
                                <button key={u.key}
                                  style={{
                                    background: item.urgencia === u.key ? u.color + '22' : '#1e1e2e',
                                    border: `1px solid ${item.urgencia === u.key ? u.color : '#2d2d44'}`,
                                    borderRadius: 6, color: item.urgencia === u.key ? u.color : '#555',
                                    padding: '5px 10px', cursor: 'pointer', fontSize: 11,
                                  }}
                                  onClick={() => actualizarItem(idx, 'urgencia', u.key)}>
                                  {u.label}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Nota */}
                          <div style={{ flex: 1, minWidth: 200 }}>
                            <div style={s.fieldLabel}>Nota (opcional)</div>
                            <input
                              style={s.inputSmall}
                              placeholder="Ej: es para el Ford Ranger del cliente X"
                              value={item.nota_item}
                              onChange={e => actualizarItem(idx, 'nota_item', e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Nota general + Enviar */}
              {items.length > 0 && (
                <div style={s.card}>
                  <div style={s.cardTitulo}>Nota general (opcional)</div>
                  <textarea
                    style={{ ...s.input, height: 70, resize: 'vertical', fontFamily: 'inherit' }}
                    placeholder="Cualquier información adicional para el gerente..."
                    value={nota}
                    onChange={e => setNota(e.target.value)}
                  />
                  <button
                    style={{
                      width: '100%', marginTop: 16, background: '#4caf50',
                      border: 'none', borderRadius: 10, color: '#fff',
                      padding: '14px', cursor: enviando ? 'not-allowed' : 'pointer',
                      fontSize: 15, fontWeight: 'bold', opacity: enviando ? 0.7 : 1,
                    }}
                    onClick={enviar} disabled={enviando}>
                    {enviando ? 'Enviando...' : `📤 Enviar requerimiento (${items.length} ítems)`}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* ── Vista: Historial ── */}
      {vista === 'historial' && (
        <div>
          {true && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <span style={{ color: '#4cc9f0', fontWeight: 'bold' }}>Historial de {tecnico} (Alfonso)</span>
                <button style={{ background: 'none', border: '1px solid #2d2d44', borderRadius: 6,
                  color: '#555', padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}
                  onClick={cargarHistorial}>🔄 Actualizar</button>
              </div>

              {cargandoHist ? (
                <p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Cargando...</p>
              ) : historial.length === 0 ? (
                <p style={{ color: '#555', textAlign: 'center', padding: 40 }}>Sin requerimientos enviados</p>
              ) : (
                historial.map((r) => {
                  const est = ESTADO_STYLE[r.estado] || ESTADO_STYLE.pendiente;
                  return (
                    <div key={r.id} style={{ background: '#1a1a2e', borderRadius: 10,
                      marginBottom: 10, padding: '14px 16px', border: '1px solid #2d2d44',
                      cursor: 'pointer' }}
                      onClick={() => abrirModal(r)}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <span style={{ color: '#555', fontSize: 11 }}>#{r.id} · {r.created_at}</span>
                          <div style={{ color: '#fff', fontSize: 13, fontWeight: '600', marginTop: 2 }}>
                            {r.total_items} ítem{r.total_items !== 1 ? 's' : ''}
                            {r.marca ? ` · ${r.marca}` : ''}
                          </div>
                          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                            {r.criticos > 0 && (
                              <span style={{ color: '#e63946', fontSize: 11 }}>🔴 {r.criticos} crítico(s)</span>
                            )}
                            {r.urgentes > 0 && (
                              <span style={{ color: '#ffc107', fontSize: 11 }}>🟡 {r.urgentes} urgente(s)</span>
                            )}
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <span style={{ color: '#555', fontSize: 11 }}>
                            {r.estado === 'pendiente' ? '✏️ Ver / Editar' : '👁️ Ver'}
                          </span>
                          <div style={{ background: est.bg, color: est.color,
                            borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 'bold' }}>
                            {est.label}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </>
          )}
        </div>
      )}
      {/* ── Modal Detalle / Edición ── */}
      {modalReq && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24 }}
          onClick={() => setModalReq(null)}>
          <div style={{ background: '#1a1a2e', borderRadius: 16, padding: 24, width: '100%',
            maxWidth: 600, maxHeight: '80vh', display: 'flex', flexDirection: 'column',
            border: '1px solid #2d2d44' }}
            onClick={e => e.stopPropagation()}>

            {/* Header modal */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <div style={{ color: '#fff', fontWeight: 'bold', fontSize: 16 }}>
                  Requerimiento #{modalReq.id}
                </div>
                <div style={{ color: '#555', fontSize: 12, marginTop: 2 }}>
                  {modalReq.estado === 'pendiente'
                    ? '✏️ Puedes eliminar ítems que ya no sean necesarios'
                    : '👁️ Solo lectura — ya fue procesado'}
                </div>
              </div>
              <button style={{ background: 'none', border: 'none', color: '#555',
                cursor: 'pointer', fontSize: 22, lineHeight: 1 }}
                onClick={() => setModalReq(null)}>✕</button>
            </div>

            {/* Items */}
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {cargandoMod ? (
                <p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Cargando items...</p>
              ) : modalReq.items.length === 0 ? (
                <p style={{ color: '#555', textAlign: 'center', padding: 40 }}>Sin items</p>
              ) : (
                modalReq.items.map((item) => {
                  const URG_COLOR = { critico: '#e63946', urgente: '#ffc107', normal: '#555' };
                  const URG_LABEL = { critico: '🔴 Crítico', urgente: '🟡 Urgente', normal: '⚪ Normal' };
                  const esPendiente = modalReq.estado === 'pendiente';
                  return (
                    <div key={item.id} style={{
                      display: 'flex', alignItems: 'center', gap: 12,
                      background: '#0f0f1a', borderRadius: 8, padding: '12px 14px', marginBottom: 8,
                      borderLeft: `3px solid ${URG_COLOR[item.urgencia] || '#555'}`,
                      opacity: eliminando === item.id ? 0.4 : 1,
                    }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>
                          {item.descripcion}
                        </div>
                        <div style={{ color: '#555', fontSize: 11, marginTop: 2 }}>
                          {item.codigo_bar} · {item.marca_item}
                        </div>
                        <div style={{ display: 'flex', gap: 12, marginTop: 6, alignItems: 'center' }}>
                          <span style={{ color: URG_COLOR[item.urgencia], fontSize: 11 }}>
                            {URG_LABEL[item.urgencia]}
                          </span>
                          <span style={{ color: '#4cc9f0', fontSize: 12 }}>
                            Cant: {item.cantidad_sugerida}
                          </span>
                          {item.nota_item && (
                            <span style={{ color: '#888', fontSize: 11, fontStyle: 'italic' }}>
                              💬 {item.nota_item}
                            </span>
                          )}
                        </div>
                      </div>
                      {esPendiente && (
                        <button
                          style={{ background: '#3a1a1a', border: '1px solid #e63946',
                            borderRadius: 6, color: '#e63946', padding: '6px 12px',
                            cursor: eliminando === item.id ? 'not-allowed' : 'pointer',
                            fontSize: 12, fontWeight: 'bold', flexShrink: 0 }}
                          disabled={eliminando === item.id}
                          onClick={() => eliminarItemReq(modalReq.id, item.id)}>
                          {eliminando === item.id ? '...' : '✕ Eliminar'}
                        </button>
                      )}
                    </div>
                  );
                })
              )}
            </div>

            {/* Footer */}
            <div style={{ marginTop: 16, textAlign: 'right' }}>
              <button style={{ background: '#2d2d44', border: 'none', borderRadius: 8,
                color: '#aaa', padding: '10px 24px', cursor: 'pointer', fontSize: 13 }}
                onClick={() => setModalReq(null)}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

const s = {
  card:       { background: '#1e1e2e', borderRadius: 12, padding: 20, marginBottom: 16 },
  cardTitulo: { color: '#fff', fontSize: 14, fontWeight: 'bold', marginBottom: 14 },
  input:      { width: '100%', background: '#0f0f1a', border: '1px solid #2d2d44',
                borderRadius: 8, color: '#fff', padding: '10px 14px', fontSize: 13,
                boxSizing: 'border-box' },
  inputSmall: { background: '#1e1e2e', border: '1px solid #2d2d44', borderRadius: 6,
                color: '#fff', padding: '7px 10px', fontSize: 12, width: '100%' },
  btnBuscar:  { background: '#1a2a3e', border: '1px solid #4cc9f0', borderRadius: 8,
                color: '#4cc9f0', padding: '10px 20px', cursor: 'pointer',
                fontSize: 13, fontWeight: 'bold', whiteSpace: 'nowrap' },
  fieldLabel: { color: '#555', fontSize: 10, fontWeight: 'bold',
                marginBottom: 4, textTransform: 'uppercase' },
};